"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagePreviewer = void 0;

var _styles = require("./styles");

var _EditionActiveImage = require("../../molecules/EditionActiveImage");

var _ImageSelector = require("../../molecules/ImageSelector");

var _jsxRuntime = require("react/jsx-runtime");

var ImagePreviewer = function ImagePreviewer(_ref) {
  var _ref$imagesArray = _ref.imagesArray,
      imagesArray = _ref$imagesArray === void 0 ? [] : _ref$imagesArray,
      activeImage = _ref.activeImage,
      setActiveImage = _ref.setActiveImage,
      setShowModal = _ref.setShowModal;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditionActiveImage.EditionActiveImage, {
      img: activeImage === null || activeImage === void 0 ? void 0 : activeImage.src,
      altText: activeImage === null || activeImage === void 0 ? void 0 : activeImage.name,
      setShowModal: setShowModal
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageSelector.ImageSelector, {
      images: imagesArray,
      setActiveImage: setActiveImage
    })]
  });
};

exports.ImagePreviewer = ImagePreviewer;